/**
 * Companies API endpoints
 */
import type {
    ApiResponse,
    ApiListResponse,
    Company,
    CompanyInput,
    CompanyUpdate,
} from "../lib/types";
import { authenticatedRequest } from "../lib/api";

export type { Company, CompanyInput, CompanyUpdate };

export async function getCompanies(token: string): Promise<Company[]> {
    return authenticatedRequest<ApiListResponse<Company>>(
        "/api/companies",
        token
    ).then((res) => res.data);
}

export async function getCompany(token: string, id: string): Promise<Company> {
    return authenticatedRequest<ApiResponse<Company>>(
        `/api/companies/${id}`,
        token
    ).then((res) => res.data);
}

export async function createCompany(
    token: string,
    input: CompanyInput
): Promise<Company> {
    return authenticatedRequest<ApiResponse<Company>>("/api/companies", token, {
        method: "POST",
        body: JSON.stringify(input),
    }).then((res) => res.data);
}

export async function updateCompany(
    token: string,
    id: string,
    input: CompanyUpdate
): Promise<Company> {
    return authenticatedRequest<ApiResponse<Company>>(
        `/api/companies/${id}`,
        token,
        {
            method: "PUT",
            body: JSON.stringify(input),
        }
    ).then((res) => res.data);
}

export async function deleteCompany(token: string, id: string): Promise<void> {
    return authenticatedRequest(`/api/companies/${id}`, token, {
        method: "DELETE",
    }).then(() => undefined);
}

export async function testRedisConnection(
    token: string,
    config: Record<string, unknown>
): Promise<void> {
    return authenticatedRequest("/api/companies/test-redis-connection", token, {
        method: "POST",
        body: JSON.stringify({ redisConfig: config }),
    }).then(() => undefined);
}
